import { Cart } from './Cart.js';

export class CartItem extends HTMLElement {
	constructor() {
		super();
		this.cartUpdateButton = this.querySelector(
			'[data-ref="cartUpdateButton"]'
		);
		this.cartRemoveButton = this.querySelector(
			'[data-ref="cartRemoveButton"]'
		);
		this.cart = new Cart();
		this.init();
	}

	init() {
		if (this.cartUpdateButton) {
			this.cartUpdateButton.addEventListener('click', (e) => {
				const id = this.dataset.variantId;
				const quantity =
					parseInt(
						this.querySelector('[name="quantity"]').value,
						10
					) || 1;
				this.cart.updateItem(id, quantity);
			});
		}
		if (this.cartRemoveButton) {
			this.cartRemoveButton.addEventListener('click', (e) => {
				const id = this.dataset.variantId;
				this.cart.removeItem(id);
			});
		}
	}
}
